
function IssueApprovalStatusCtrl($rootScope, TranslationService, ToastService, HelpdeskService) {
    var ctrl = this;
    ctrl.translation = TranslationService.getActiveTranslation();

    ctrl.toggleEdit = function () {
        if (ctrl.editing) {
            ctrl.endEdit()
        }
        else {
            ctrl.startEdit();
        }
    };

    ctrl.startEdit = function () {
        console.log('startEdit');
        ctrl.validateApproval(ctrl.ngModel, function () {
            ctrl.editing = true;
        });
        
    };

    ctrl.endEdit = function () {
        ctrl.editing = false;
    };

    ctrl.approve = function () {
        ctrl.ngModel.IsApproved = true;
        ctrl.updateApproval(ctrl.ngModel, function () {            
            ctrl.endEdit();
        });        
    };

    ctrl.reject = function () {
        ctrl.ngModel.IsApproved = false;
        ctrl.updateApproval(ctrl.ngModel, function () {
            ctrl.endEdit();
        })
    };

    ctrl.save = function () {
        ctrl.endEdit();
    };

    ctrl.validateApproval = function (user, callback) {
        //console.log('toggle approval ', user);        
        //user.StageID = ctrl.stage.StageID;
        HelpdeskService.validateApproval(user).then(function (response) {
            console.log('VALIDATED', response.data);
            var msg = response.data;
            if (msg) {
                ToastService.createToast('Error', msg, 4000, 'error');
            }
            else {
                callback();
            }            
        },
            function (error) {
                var err = ToastService.getErrorMsg(error);
                ToastService.createToast('Error', err, 4000, 'error');
            }
        );
    };


    ctrl.updateApproval = function (user, callback) {
        //console.log('toggle approval ', user);
        //user.StageID = ctrl.stage.StageID;
        ctrl.saving = true;
        HelpdeskService.updateApproval(user).then(function (response) {
            //console.log('UPDATED', response.data);

            var approv = response.data;

            user.Comment = approv.Comment
            user.IsApproved = approv.IsApproved;
            user.ApprovalDate = approv.ApprovalDate;

            ctrl.issue.AssignedApprovalUserID = approv.AssignedApprovalUserID;

            
            HelpdeskService.resetCache();
            ToastService.createToast('Saved', '', 4000, 'success');

            callback();

            //BROADCAST
            $rootScope.$broadcast('approvalStatusChanged', ctrl.ngModel);

            ctrl.saving = false;
        },
            function (error) {
                var err = ToastService.getErrorMsg(error);
                ToastService.createToast('Error', err, 4000, 'error');
                ctrl.saving = false;
            }
        );
    }

}

IssueApprovalStatusCtrl.$inject = ['$rootScope', 'TranslationService', 'ToastService', 'HelpdeskService'];

seedWebApp.component('issueApprovalStatus', {
    controller: IssueApprovalStatusCtrl,
    controllerAs: 'ctrl',
    bindings: {
        ngModel: '<',
        issue: '<',
    },
    templateUrl: '/SPA/helpdesk/issueApprovalStatus.html' + seedWebApp.buildVersion
});
